export default "__VITE_ASSET__8da74cf2__"